// @flow

import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  max-width: 375px;
  margin: 0 auto;
`;
